import { FsAdvancedMarker } from '@lib/geo/google/map';
import { THEME } from '@lib/ui/theme';
import { FsLvtCamera } from './lvt-camera';

export class FsLvtAdvancedMarker extends FsAdvancedMarker {
  constructor(public camera: FsLvtCamera) {
    super(
      {
        position: new google.maps.LatLng(camera.coordinates[1], camera.coordinates[0]),
        title: camera.id,
        content: document.createElement('div'),
        collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
      },
      '.fs__advanced-marker-expand',
    );
    const content: any = this.getMarker().content;

    content.classList.add('fs__lvt-camera-advanced-marker');
    content.style.border = `2px solid ${THEME.success}`;
    content.innerHTML =
      '<img class="fs__lvt-camera-icon" src="/assets/fusus-icons/PNG/lvt-circle-green.png"/>';
    content.classList.add('fs__center-marker');
  }
}
